export const Card = {
  Royal: 'Royal',
  Jewellery: 'Jewellery',
  Wellness: 'Wellness',
  Label: 'Label',
  Billionaire: 'Billionaire',
  BillionaireJewellery: 'Billionaire Jewellery',
  RoyalPolo: 'RoyalPolo',
  Elite: 'Elite',
  Ica: 'ICA',
} as const;
export type Card = (typeof Card)[keyof typeof Card];
